import { gql } from '@apollo/client';

import { priceFragment } from '../ProductsProvider/query';

export default gql`
  ${priceFragment}

  query getProductsBySku($condition: Condition, $language: Language) {
    getProducts(condition: $condition, language: $language) {
      result {
        items {
          id
          title
          sku
          image
          audioId
          videoId
          price {
            main {
              ...priceFragment
            }
            min {
              ...priceFragment
            }
            bundle {
              originalPrice
              diffPrice
              minPrice
            }
          }
          attributes(
            keys: [
              "sticker"
              "description"
              "detail_page"
              "pricing_page"
              "image_lazy"
              "override_price"
              "custom_price_text"
              "free"
            ]
          ) {
            key
            value
          }
        }
      }
    }
  }
`;
